import { Play } from "lucide-react";

export const VideoSection = () => {
  return (
    <section className="py-24 section-darker relative overflow-hidden">
      <div className="absolute inset-0 mesh-gradient opacity-30" />
      <div className="container relative z-10">
        <h2 className="text-4xl md:text-5xl font-space-grotesk font-bold text-center mb-4 text-foreground">
          Zobacz nas <span className="text-gradient">w akcji</span>
        </h2>
        <p className="text-muted-foreground text-center mb-16 max-w-md mx-auto">
          Fragment naszego występu na żywo
        </p>
        <div className="max-w-4xl mx-auto space-y-10">
          <div className="glass-strong rounded-2xl p-2 glow">
            <div className="aspect-video rounded-xl overflow-hidden">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/uCFP0P8mzIg"
                title="Występ komediowy dla firm"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
          <div className="glass-strong rounded-2xl p-2 glow">
            <div className="aspect-video rounded-xl overflow-hidden">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/Wjd8tuRphjw"
                title="Występ komediowy - fragment"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
          <p className="text-center mt-8 text-muted-foreground max-w-2xl mx-auto">
            Każdy występ jest dostosowany do potrzeb Twojej firmy i charakteru wydarzenia. 
            Gwarantujemy profesjonalizm i świetną zabawę!
          </p>
        </div>
      </div>
    </section>
  );
};
